// Slice `toolParts` (spec-001 `plataforma-por-chat`, [T006]) — as partes de tool do
// turno por `toolCallId`. Composto no namespace RAIZ (`aiFramework/upsertToolPart`,
// `aiFramework/toolParts`), como no `aawz-intelligence-v2` e no `feeFixoIa`: o
// `messages.vue`/`chat-message.vue` é o MESMO componente nas três superfícies e só
// troca o prefixo do namespace. `criarStateToolParts()` é chamada aqui, uma vez,
// para que este namespace tenha mapa e ordem próprios.
import {
  criarStateToolParts,
  toolPartsActions,
  toolPartsGetters,
  toolPartsMutations,
} from '@modules/aawz-intelligence-v2/store/toolParts'
// Mesmo raciocínio do slice acima, para o hub do turno e os agentes que
// responderam (D6/RF-G2 da spec-010 do hermes): quem despacha
// `<namespace>/setHubDaConversa` (e as duas irmãs) é o `APIChat`, que o
// `APIAgentChat` daqui estende — sem a composição, cada turno desta superfície
// levantava `[vuex] unknown action type` e ficava sem badge. A junção
// dispatch × store das três superfícies vive em
// `aawz-intelligence-v2/store/superficies-do-chat.unit.js`.
import {
  criarStateHubEAgente,
  hubEAgenteActions,
  hubEAgenteGetters,
  hubEAgenteMutations,
} from '@modules/aawz-intelligence-v2/store/hub-e-agente'
import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'
import * as chatActions from './chat/chatActions'
import * as chatGetters from './chat/chatGetters'
import * as chatMutations from './chat/chatMutations'
import state from './state'
// spec-004 (Auditoria & Aprovações, G14) — 3 slices como sub-módulos namespaced
// (`aiFramework/approvals/*`, `aiFramework/runs/*`, `aiFramework/usage/*`). Registrados
// aqui SEM tocar os slices existentes (catálogo/instâncias/chat) — cada um com seu
// `.unit.js` e state próprio, evitando colisão de getters/mutations com o namespace raiz.
import approvals from './approvals'
import runs from './runs'
import usage from './usage'
// spec-001 project-ia-payment (Saldo de créditos, [T013]) — mesmo desenho dos três acima:
// sub-módulo namespaced `aiFramework/creditos/*`, state e getters próprios.
import creditos from './creditos'

// Namespace único `aiFramework` (contrato spec-002 §4). O slice `chat` (spec-003 G6) é
// composto aqui — mantém `actions.js`/`getters.js`/`mutations.js` da spec-002 intocados
// (os `.unit.js` existentes importam direto desses arquivos).
export default {
  namespaced: true,
  // ★ `state` é FUNÇÃO, e não o objeto de `state.js`: com objeto, todo `new
  // Vuex.Store` a partir deste módulo instala os sub-módulos (`approvals`,
  // `runs`, `usage`) DENTRO do mesmo objeto — a segunda instalação encontra o
  // campo já lá e o Vuex avisa `state field "approvals" was overridden by a
  // module with the same name`, com os dois stores dividindo o state raiz.
  // Descoberto pelo unit do slice `toolParts` (spec-001 [T006]), que monta os
  // três namespaces do chat na mesma suíte.
  state: () => ({ ...state, ...criarStateToolParts(), ...criarStateHubEAgente() }),
  actions: { ...actions, ...chatActions, ...toolPartsActions, ...hubEAgenteActions },
  getters: { ...getters, ...chatGetters, ...toolPartsGetters, ...hubEAgenteGetters },
  mutations: { ...mutations, ...chatMutations, ...toolPartsMutations, ...hubEAgenteMutations },
  modules: { approvals, runs, usage, creditos },
}
